import { ErrorCodes } from '@tableau/api-internal-contract-js';
import { ApiContext } from '../ApiContext';
import { InternalTableauError } from '../ApiCore';
import { ApiDispatcher } from '../common-bootstrap/ApiDispatcher';
import { AddInApiPresLayerImpl } from './AddInApiPresLayerImpl';
import { hasQt, initializeWebChannelPresLayer } from './QtWebChannelImpl';
import { AddInApiPresLayerInteropObject } from './types/AddInApiPresLayerInteropObject';

/**
 * Desktop bootstrap. This code attempts to initialize the qt pres-layer as well as the dispatcher.
 * @see comments in JsApiPlatform.ts.
 */

export function connectApiDispatcher(preslayer: AddInApiPresLayerInteropObject): ApiDispatcher {
  const presLayerApi = new AddInApiPresLayerImpl(preslayer);
  if (!presLayerApi.AddInInstanceInfo.addInLocatorPresModel || !presLayerApi.AddInInstanceInfo.addInRegistrationPresModel) {
    throw new InternalTableauError(ErrorCodes.INITIALIZATION_ERROR, 'Unexpected failure to initialize.');
  }

  // setup api context
  const apiContext: ApiContext = ApiContext.getInstance();
  apiContext.setIsDesktop(true);
  apiContext.setIsVisible(document.visibilityState === 'visible');
  apiContext.setIsPlatformOfficialRelease(presLayerApi.PlatformInfo.isOfficialRelease);
  apiContext.setIsFirstClass(presLayerApi.AddInInstanceInfo.addInRegistrationPresModel.extensionIsFirstclass);
  const apiDispatcher = new ApiDispatcher(presLayerApi.AddInInstanceInfo, presLayerApi);

  // tslint:disable-next-line:no-console
  console.log('Desktop bootstrapping succeeded!');
  return apiDispatcher;
}

export async function createApiDispatcherDesktop(): Promise<ApiDispatcher> {
  if (!hasQt()) {
    throw new InternalTableauError(ErrorCodes.INITIALIZATION_ERROR, 'Not running in desktop with qt available.');
  }

  // First we need to initialize the webchannel pres-layer
  const presLayer = await initializeWebChannelPresLayer();
  return connectApiDispatcher(presLayer);
}
